import { FormItemProps } from "formik-antd";
import { FormItemWrapper } from "./styles";

const FormItem = (props: FormItemProps) => <FormItemWrapper {...props} />;

export default FormItem;
